import CS_Certificate from "./cyber_security_components/CS_Certificate";
import CS_Cyber_Crime from "./cyber_security_components/CS_Cyber_Crime";
import CS_Dark_Web from "./cyber_security_components/CS_Dark_Web";
import CS_Firewalls from "./cyber_security_components/CS_Firewalls";
import CS_Home from "./cyber_security_components/CS_Home";
import CS_Incident_Response from "./cyber_security_components/CS_Incident_Response";
import CS_Mapping_Port_Scanning from "./cyber_security_components/CS_Mapping_Port_Scanning";
import CS_Money_Making_Threats from "./cyber_security_components/CS_Money_Making_Threats";
import CS_Networking_Basics from "./cyber_security_components/CS_Networking_Basics";
import CS_Network_Attacks from "./cyber_security_components/CS_Network_Attacks";
import CS_Network_Layer from "./cyber_security_components/CS_Network_Layer";
import CS_Network_Transport from "./cyber_security_components/CS_Network_Transport";
import CS_Passwords from "./cyber_security_components/CS_Passwords";
import CS_Penetration_Testing_Social_Engineering from "./cyber_security_components/CS_Penetration_Testing_Social_Engineering";
import CS_Quiz from "./cyber_security_components/CS_Quiz";
import CS_Security_Operations from "./cyber_security_components/CS_Security_Operations";
import CS_Study_Plan from "./cyber_security_components/CS_Study_Plan";
import CS_Syllabus from "./cyber_security_components/CS_Syllabus";
import CS_Web_Applications from "./cyber_security_components/CS_Web_Applications";
import CS_Web_Application_Attacks from "./cyber_security_components/CS_Web_Application_Attacks";
import CS_WIFI_Attacks from "./cyber_security_components/CS_WIFI_Attacks";

const AllCyberSecurityComponents = {
  "<CS_Certificate />": CS_Certificate,
  "<CS_Cyber_Crime />": CS_Cyber_Crime,
  "<CS_Dark_Web />": CS_Dark_Web,
  "<CS_Firewalls />": CS_Firewalls,
  "<CS_Home />": CS_Home,
  "<CS_Incident_Response />": CS_Incident_Response,
  "<CS_Mapping_Port_Scanning />": CS_Mapping_Port_Scanning,
  "<CS_Money_Making_Threats />": CS_Money_Making_Threats,
  "<CS_Networking_Basics />": CS_Networking_Basics,
  "<CS_Network_Attacks />": CS_Network_Attacks,
  "<CS_Network_Layer />": CS_Network_Layer,
  "<CS_Network_Transport />": CS_Network_Transport,
  "<CS_Passwords />": CS_Passwords,
  "<CS_Penetration_Testing_Social_Engineering />":
    CS_Penetration_Testing_Social_Engineering,
  "<CS_Quiz />": CS_Quiz,
  "<CS_Security_Operations />": CS_Security_Operations,
  "<CS_Study_Plan />": CS_Study_Plan,
  "<CS_Syllabus />": CS_Syllabus,
  "<CS_Web_Applications />": CS_Web_Applications,
  "<CS_Web_Application_Attacks />": CS_Web_Application_Attacks,
  "<CS_WIFI_Attacks />": CS_WIFI_Attacks,
};

export default AllCyberSecurityComponents;
